import { useEffect, useRef, useState } from "react";
import { getStepId, setTrackingOp, useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { groupPausesByCrewTask } from "../../../../util/varibles/global";
import { IActivityLog, IService2 } from "../../../../util/varibles/interface";
import Icon, { ICON_NAME } from "../../../Icon";
import ServiceInfo from "../../../Popup/PopupOpInfo/Info/Service/ServiceInfo";
import NextTabButton from "../NextTabButton";
import PauseSection from "../Pause/PauseSection";
import PauseView from "../Pause/PauseView";
import CrewTask from "./CrewTask";

const NextTab = ({ isDone }: { isDone: boolean }) => {
    const set = setTrackingOp();

    return <>
        {isDone && <NextTabButton
            name={"Finish"}
            sticky
            onClick={() => set(({ step }) => ({ step: step + 1 }))}
        />}
    </>
}

export default function ServiceTask({ log, stepIndex }: { log: IActivityLog, stepIndex: number }) {
    const [op, set] = useTrackingOp(state => state.op?.operation as IService2);
    const { crew_tasks = [] } = op || {};
    const isStepDone = useRef(false);
    const stepId = useRef(getStepId(log, stepIndex));
    const [taskId, setTaskId] = useState<string | undefined>(undefined);

    useEffect(() => {
        let flag = true
        const done = crew_tasks.length === 0 || crew_tasks.every(item => {
            if (item.real_start_time && !item.real_finish_time) {
                setTaskId(item.id);
                flag = false;
            }
            return item.real_finish_time
        });
        isStepDone.current = done;
        if (flag) setTaskId(undefined);
        set(({ stepStates: prev }) => {
            return { stepStates: { ...prev, [stepId.current]: { state: done ? 1 : 0 } } }
        })
    }, [crew_tasks, set]);

    if (!op) return null;

    const { pauses = [] } = op;

    const sortedCrewTasks = [...crew_tasks].sort((a, b) => {
        if (!a.real_start_time && !b.real_start_time) return 0;
        if (!a.real_start_time) return 1;
        if (!b.real_start_time) return -1;

        return a.real_start_time - b.real_start_time;
    });
    const grouped = groupPausesByCrewTask(pauses, sortedCrewTasks);

    return <>
        <div className="w-full">
            <div className="mt-[5px]">
                <ServiceInfo operation={op as IService2} />
            </div>
            <div className="grid grid-cols-[55%_max-content] items-center gap-x-3 gap-y-2 w-full mt-2 pb-[42px]">
                {sortedCrewTasks.flatMap((item, i) => {
                    const { before, inside } = grouped[i] || {};

                    return [
                        // Pause before
                        <div key={`before-pause-${item.id}`}>
                            {before && (
                                <PauseSection>
                                    {before.map(pauseIndex => (
                                        <PauseView key={`pause-${pauseIndex}`} data={pauses[pauseIndex]} />
                                    ))}
                                </PauseSection>
                            )}
                        </div>,

                        // Arrow
                        <div key={`arrow-${item.id}`} className="w-full flex flex-col items-center"                        >
                            {!!i && (
                                <>
                                    <Icon
                                        className="mt-3"
                                        icon={ICON_NAME.ARROW_DOWN_3}
                                        bg="colorDisable"
                                    />

                                    <Icon
                                        className="mt-[-2px] mb-3"
                                        icon={ICON_NAME.ARROW_DOWN_3}
                                        bg="colorDisable"
                                    />
                                </>
                            )}
                        </div>,

                        // Pause inside
                        <div
                            key={`inside-pause-${item.id}`}
                            className="my-auto"
                        >
                            {inside && (
                                <PauseSection>
                                    {inside.map(pauseIndex => (
                                        <PauseView key={`pause-${pauseIndex}`} data={pauses[pauseIndex]} />
                                    ))}
                                </PauseSection>
                            )}
                        </div>,

                        // Task
                        <div key={`task-${item.id}`} className="w-full flex justify-center"                        >
                            <CrewTask data={item} runningTaskId={taskId} />
                        </div>,
                    ];
                })}

                {!!grouped[crew_tasks.length]?.after && <PauseSection>
                    {grouped[crew_tasks.length].after.map(pauseIndex => (
                        <PauseView key={`pause-${pauseIndex}`} data={pauses[pauseIndex]} />
                    ))}
                </PauseSection>}
                <div />
            </div>
        </div>
        <NextTab isDone={isStepDone.current} />
    </>
}
